var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEF0C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1606 23.3069V19.7176H36.4641C36.582 19.7176 36.6784 19.6212 36.6784 19.5033V18.0033C36.6784 17.8855 36.582 17.7891 36.4641 17.7891H19.5356C19.4177 17.7891 19.3213 17.8855 19.3213 18.0033V19.5033C19.3213 19.6212 19.4177 19.7176 19.5356 19.7176H21.8391V23.3069C21.8391 25.49 22.9749 27.4105 24.6891 28.5033C22.9749 29.5962 21.8391 31.5167 21.8391 33.6998V37.2891H19.5356C19.4177 37.2891 19.3213 37.3855 19.3213 37.5033V39.0033C19.3213 39.1212 19.4177 39.2176 19.5356 39.2176H36.4641C36.582 39.2176 36.6784 39.1212 36.6784 39.0033V37.5033C36.6784 37.3855 36.582 37.2891 36.4641 37.2891H34.1606V33.6998C34.1606 31.5167 33.0249 29.5962 31.3106 28.5033C33.0249 27.4105 34.1606 25.49 34.1606 23.3069ZM32.232 33.6998V37.2891H23.7677V33.6998C23.7677 32.5694 24.207 31.506 25.0079 30.7078C25.8061 29.9069 26.8695 29.4676 27.9999 29.4676C29.1302 29.4676 30.1936 29.9069 30.9918 30.7078C31.7927 31.506 32.232 32.5694 32.232 33.6998ZM32.232 23.3069C32.232 24.4373 31.7927 25.5007 30.9918 26.2989C30.1936 27.0998 29.1302 27.5391 27.9999 27.5391C26.8695 27.5391 25.8061 27.0998 25.0079 26.2989C24.6132 25.9072 24.3004 25.441 24.0875 24.9274C23.8745 24.4138 23.7659 23.8629 23.7677 23.3069V19.7176H32.232V23.3069Z",
    fill: "#998508"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FFFAEB",
    strokeWidth: 8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomProgress);
export default __webpack_public_path__ + "static/media/custom-progress.1b3e3969e26c2da6869db91ff4babe35.svg";
export { ForwardRef as ReactComponent };